import { render } from "./EmailDetails.vue?vue&type=template&id=1838f74a"
import script from "./EmailDetails.vue?vue&type=script&lang=js"
export * from "./EmailDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__